import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import couponApi from "../api/couponApi";

// Async thunk for fetching coupons
export const fetchAllCoupons = createAsyncThunk("coupon/fetchCoupons", async (_, thunkAPI) => {
  try {
    const res = await couponApi.getAll();
    return res?.data.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

export const getCouponById = createAsyncThunk("coupon/couponById", async (id, thunkAPI) => {
  try {
    const res = await couponApi.getById(id);
    return res?.data.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

export const createCoupon = createAsyncThunk("coupon/createCoupon", async (couponData, thunkAPI) => {
  try {
    const res = await couponApi.create(couponData);
    return res?.data.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

export const deleteCoupon = createAsyncThunk("coupon/deleteCoupon", async (id, thunkAPI) => {
  try {
    const res = await couponApi.delete(id);
    return res?.data.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

export const updateCoupon = createAsyncThunk("coupon/updateCoupon", async (couponData, thunkAPI) => {
  try {
    const res = await couponApi.update(couponData.id, couponData);
    return res?.data.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

const couponSlice = createSlice({
  name: "coupon",
  initialState: {
    coupons: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllCoupons.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllCoupons.fulfilled, (state, action) => {
        state.loading = false;
        state.coupons = action.payload;
      })
      .addCase(fetchAllCoupons.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateCoupon.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createCoupon.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createCoupon.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateCoupon.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.coupons.findIndex(coupon => coupon.id === action.payload.id);
        if (index !== -1) {
          state.coupons[index] = action.payload;
        }
      })
      .addCase(updateCoupon.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createCoupon.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteCoupon.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteCoupon.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteCoupon.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default couponSlice.reducer;
